import { render, staticRenderFns } from "./ProductViewGrid.vue?vue&type=template&id=3947a37e&scoped=true&"
import script from "./ProductViewGrid.vue?vue&type=script&lang=js&"
export * from "./ProductViewGrid.vue?vue&type=script&lang=js&"
import style0 from "./ProductViewGrid.vue?vue&type=style&index=0&id=3947a37e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../myscore_frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3947a37e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../myscore_frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
